import { Component, DestroyRef, inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { BannerComponent, LayoutBannersComponent, LayoutComponent } from '@ndwnu/design-system';
import { environment } from '@env/environment';
import { BannerService } from '@components/layout/banner.service';
import { MenuService } from '@services/menu/menu.service';
import { ReleaseNotesPopupComponent } from '@pages/release-notes/components/release-notes-popup/release-notes-popup.component';
import { MapActionService } from '@daisi/services/map/map-action.service';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-layout',
  imports: [
    LayoutComponent,
    LayoutBannersComponent,
    BannerComponent,
    ReleaseNotesPopupComponent,
    RouterOutlet,
  ],
  templateUrl: './app-layout.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './app-layout.component.scss',
})
export class AppLayoutComponent implements OnInit {
  readonly bannerService: BannerService = inject(BannerService);
  readonly mapActionService = inject(MapActionService);
  readonly destroyRef: DestroyRef = inject(DestroyRef);
  readonly buildNumber: string = environment.buildNumber;
  readonly applicationName: 'Daisi' = 'Daisi';
  readonly footerTexts: string[] = [`NDW - ${new Date().getFullYear()}`];
  protected readonly menuService: MenuService = inject(MenuService);

  ngOnInit() {
    this.menuService.init();
  }

  onMenuClick(event: MouseEvent) {
    const target = event.target;
    if (!(target instanceof HTMLElement)) {
      return;
    }

    const isHeaderClick = !!target.closest('ndw-main-navigation-header');
    const overzichtButton = target.closest('button');
    const isOverzichtClick =
      overzichtButton?.textContent?.trim().toLowerCase() === 'map' ||
      overzichtButton?.textContent?.trim().toLowerCase() === 'map overzicht';

    if (isHeaderClick || isOverzichtClick) {
      this.mapActionService.zoomToContent();
    }
  }
}
